import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { PermissionsEnum } from 'mbs-ui-shared';
import { HelpService } from 'mbs-ui-shared@help/help.service';
import { S3AuthType as AuthType } from 'mbs-ui-shared@models/StorageAccount';

export const getAuthTypeHints = (ability: AbilityService) => ({
  [AuthType.Manual]: ability.can('read', PermissionsEnum.HelpMarketing)
    ? 'storages:addStorageAccountWizard.inputCredentialsStep.authTypeManualHint'
    : 'storages:addStorageAccountWizard.inputCredentialsStep.authTypeManualHintWithoutHelp',
  [AuthType.MBS]: 'storages:addStorageAccountWizard.inputCredentialsStep.authTypeMBSHint',
  [AuthType.Legacy]: 'storages:addStorageAccountWizard.inputCredentialsStep.authTypeLegacyHint'
});

export const AuthTypeHints = {
  [AuthType.Manual]: 'storages:addStorageAccountWizard.inputCredentialsStep.authTypeManualHint',
  [AuthType.MBS]: 'storages:addStorageAccountWizard.inputCredentialsStep.authTypeMBSHint',
  [AuthType.Legacy]: 'storages:addStorageAccountWizard.inputCredentialsStep.authTypeLegacyHint'
};

export const getAuthTypes = (i18n: I18NextPipe, helpService: HelpService) => [
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.manualAuthType'),
    value: AuthType.Manual
  },
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.mbsAuthType'),
    value: AuthType.MBS
  },
  {
    label: i18n.transform('storages:addStorageAccountWizard.inputCredentialsStep.labels.legacyAuthType', {
      helpLink: helpService.getHelpLink('/billing-storage/storage-providers/amazon/iam-user-account')
    }),
    value: AuthType.Legacy
  }
];
